<template>
  <div class="notification-filter-container">
    <div class="notification-filter-container-left">
    </div>
    <div class="notification-filter-container-right">
      <div class="notification-filter-flagged-container checkbox-label">
        <div>
          <input class="notification-search-input "
                 placeholder="Search by Order ID or name…"
                 v-model="searchTerm">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "notification-filters-top",
  mounted () {

  },
  computed: {
    ...mapGetters('PortalNotificationStore', ['requestUrl']),
    searchTerm: {
      get () {
        return this.$store.state.PortalNotificationStore.searchTerm;
      },
      set (value) {
        this.setSearchTerm(value);
        this.setCurrentPage({
          url: undefined, //unused
          page: 1
        });
        if (value.length === 0 || value.length > 2) {
          this.fetchNotifications(this.requestUrl);
        }
      }
    }
  },
  methods: {
    ...mapMutations('PortalNotificationStore', [
      'setSearchTerm',
      'setCurrentPage'
    ]),
    ...mapActions('PortalNotificationStore', [
      "fetchNotifications",
    ]),
  },
};


</script>

<style scoped>
</style>
